import type { Role } from '@revcall/shared';
import { apiClient } from '../client';

/** W4 (B2-team): the role journal of an organisation, from the audit log (admins). */
export interface MembersJournalEntry {
  action: 'membership.role_change' | 'membership.invite' | 'membership.invite_new_user' | 'membership.remove' | 'membership.customer_scope_change';
  actor_email: string;
  member_email: string | null;
  previous_role: Role | null;
  new_role: Role | null;
  created_date: string;
}

export function listMembersJournal(organisationId: string, signal?: AbortSignal) {
  return apiClient.get<{ items: MembersJournalEntry[] }>(`/organisations/${encodeURIComponent(organisationId)}/members/journal`, { signal });
}
